import { UseFormReturn } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form, FormControl, FormControlStack, FormField, FormItem, FormLabel, FormMessage } from 'src/registry/ui/Form';
import { entityMessages } from 'src/features/entity/utils/messages';
import { InvitationFormSchemaValues } from 'src/features/users/utils/formSchema';
import { useParking } from 'src/providers/ParkingProvider';
import { userMessages } from 'src/features/users/utils/messages';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/registry/ui/Select';
import { useListRoles } from 'src/features/roles/api/useListRoles';

type InvitationFormProps = {
    form: UseFormReturn<InvitationFormSchemaValues>;
    onSubmit: (values: InvitationFormSchemaValues) => void;
};

function InvitationForm({ onSubmit, form }: InvitationFormProps) {
    const { formatMessage } = useIntl();
    const { parkingId } = useParking();

    const { data: roles } = useListRoles({ parkingId, config: { enabled: !!parkingId } });

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<InvitationFormSchemaValues>
                form={form}
                name="email"
                type="email"
                label={formatMessage(entityMessages.email)}
            />
            <FormField
                control={form.control}
                name="sp_role"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog" required>
                            <FormattedMessage {...userMessages.role} />
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Select onValueChange={field.onChange} value={field.value ?? ''}>
                                    <SelectTrigger className="w-full">
                                        <SelectValue placeholder={`${formatMessage(userMessages.role)}...`} />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {roles?.results?.map((role) => (
                                            <SelectItem key={role.id} value={role.id}>
                                                {role.name}
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
        </Form>
    );
}

export default InvitationForm;
